import React from "react";
import cx from "classnames";
import { ImageLocation } from "models";
import { getImageUrl } from "services/UrlBuilder";
import { isIOS } from "shared-utils";
import { useTranslation } from "i18n";
import getImageAltText from "pages/Profile/utils/getImageAltText";

export interface GalleryPhoto {
  id: string;
  description?: string;
  fileName: string;
  photographer?: string;
  url: string;
  userFriendlyId: string;
}

interface GalleryImageProps {
  photo: GalleryPhoto;
  index: number;
  selectedIndex: number;
}

const IMAGE_BASE_CLASSES = "block max-h-full max-w-full rounded-[16px]";

const GalleryImage = ({ photo, index, selectedIndex }: GalleryImageProps) => {
  const { t } = useTranslation();

  const isIOSDevice = isIOS();
  const imageUrl = getImageUrl(photo.url, ImageLocation.ViewPhoto);
  const imageAlt = getImageAltText({
    t,
    description: photo?.description,
    photographer: photo?.photographer,
  });
  const testId = photo?.userFriendlyId.split("-")[1];
  const isHidden = index !== selectedIndex;

  if (isIOSDevice) {
    return (
      <div
        className={cx("flex h-full w-full items-center justify-center", {
          hidden: isHidden,
        })}
      >
        <img
          src={imageUrl}
          alt={imageAlt}
          className={cx(IMAGE_BASE_CLASSES, "object-contain")}
          data-testid={testId}
        />
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={imageAlt}
      className={cx(
        IMAGE_BASE_CLASSES,
        "object-cover",
        index === 0 ? "h-full w-full" : "h-fit w-fit",
        { hidden: isHidden }
      )}
      data-testid={testId}
    />
  );
};

export default GalleryImage;
